import React from 'react';
import { SocialButton } from './Style';
import { FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';

const ICON_MAP = {
    linkedin: FaLinkedinIn,
    instagram: FaInstagram,
    tiktok: SiTiktok,
};

const Social = (props) => {
    const Icon = ICON_MAP[props.social] || ICON_MAP.instagram;

    return (
        <a
            href={props.link}
            aria-label={props.social}
            title={props.social}
            target="_blank"
            rel="noopener noreferrer"
        >
            <SocialButton
                social={props.social}
                margin={props.margin}
                title={props.social}
            >
                <Icon />
            </SocialButton>
        </a>
    );
};

export default Social;
